import { produce } from 'immer';
import { IBank, TBankKeys } from '../../domain/bank.interface';
import {
  BANK_PAYMENTS_RESUME_LOADED,
  BANK_PENDING_PAYMENTS_LOADED,
  BANK_SOCIAL_PROJECTS_LOADED,
  TPV_URL_LOADED,
  LILI_BANK_LOADED,
  BANK_RESET,
} from './bank.actions';

export const initialState: IBank = {
  paymentsResume: [],
  pendingPayments: [],
  socialProjects: [],
  tpvUrl: '',
  liliSocialBank: undefined,
};

export const bankReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case BANK_PAYMENTS_RESUME_LOADED:
        draft.paymentsResume = action.payload;
        return;
      case BANK_PENDING_PAYMENTS_LOADED:
        draft.pendingPayments = action.payload;
        return;
      case BANK_SOCIAL_PROJECTS_LOADED:
        draft.socialProjects = action.payload;
        return;
      case TPV_URL_LOADED:
        draft.tpvUrl = action.payload;
        return;
      case LILI_BANK_LOADED:
        draft.liliSocialBank = action.payload;
        return;
      case BANK_RESET:
        draft[action.payload as TBankKeys] =
          initialState[action.payload as TBankKeys];
        return;
    }
  });
